// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3FpMn","label":"SetPasswdForm_label__1fG_E"};